import React, { useState } from "react";

interface CustomConfirmProps {
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const CustomConfirm: React.FC<CustomConfirmProps> = ({
  message,
  onConfirm,
  onCancel,
}) => {
  return (
    <div className="custom-confirm-backdrop">
      <div className="custom-confirm-modal">
        <p>{message}</p>
        <div className="custom-confirm-buttons">
          <button onClick={onConfirm} className="confirm-btn">
            Kyllä
          </button>
          <button onClick={onCancel} className="cancel-btn">
            Ei
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomConfirm;
